<!--
 * @Description: 小程序绑定人数分布、接入设备数量统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-06 14:00:55
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 11:30:33
 -->
<template>
  <div class="miniProgramAndDevice">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">小程序绑定人数分布</span>
    </div>
    <div class="passengersCharts" ref="passengersCharts"></div>
  </div>
</template>

<script>
export default {
  name: 'miniProgramAndDevice',
  components: {
  },
  data () {
    return {
      charts: '',
      xAxis: [],
      yUsersAxis: [],
      yGrowthAxis: [],
    }
  },
  methods: {
    /**
     * @description                   初始化图表
     * @return {undefied}             无返回值
     */
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.passengersCharts)
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          textStyle: {
            color: '#fff',
          },
          data: ['人数', '增长率'],
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '人数（人）',
            position: 'left',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
          {
            type: 'value',
            name: '增长率（%）',
            position: 'right',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
        ],
        series: [
          {
            name: '人数',
            type: 'bar',
            yAxisIndex: 0,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(0,160,233,0.9)',
              }, {
                offset: 0.3,
                color: 'rgba(0,160,233,0.9)',
              }, {
                offset: 1,
                color: 'rgba(23,59,73,0.9)',
              }]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: 7,
            data: this.yUsersAxis,
          },
          {
            name: '增长率',
            data: this.yGrowthAxis,
            yAxisIndex: 1,
            type: 'line',
            color: '#d1730a',
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#d1730a',
            },
          },
        ],
      }
      this.charts.setOption(options)
      window.onresize = () => {
        this.charts.resize()
      }
    },
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/home/wxa-user/summary')
        .then(res => {
          if (res.code === 0) {
            let xAxis = []
            let yUsersAxis = []
            let yGrowthAxis = []
            res.data.map(k => {
              xAxis.push(k.day)
              yUsersAxis.push(k.number)
              yGrowthAxis.push(k.rate)
            })
            this.xAxis = xAxis
            this.yUsersAxis = yUsersAxis
            this.yGrowthAxis = yGrowthAxis
            this.initCharts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.getData()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .miniProgramAndDevice {
    width: 100%;
    height: 100%;
    font-size: 20px;
    .titleHeader {
      width: 100%;
      height: 40px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .passengersCharts {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
</style>
